import React, {Component, Fragment} from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import {Link} from 'react-router-dom'
import {dateFormat} from '../../../../modules/Utils'
import moment from 'moment'
import Status from '../../../../elements/Status'
import {Select} from 'antd'

class VehiclesList extends Component {
  columns = [
    {
      Header: 'Order',
      accessor: 'order.code',
      Cell: ({original, value}) => (
        <Link
          target={'_blank'}
          to={{
            pathname: `/clients/orders/bookings/${original.order._key}/update`,
          }}>
          {value}
        </Link>
      ),
    },
    {
      Header: 'CPO No',
      accessor: 'order.cpo.no',
    },
    {
      Header: 'Client Ref',
      accessor: 'order.reference.no',
    },
    {
      Header: 'Name',
      accessor: 'name',
      style: {textAlign: 'left'},
      width: 300,
      Cell: ({value, original}) => (
        <a onClick={e => this.props.onShowEditBooking(e, original)}>
          {value || original._key}
        </a>
      ),
    },
    {
      Header: 'Pick up Date',
      accessor: 'booking.pickup.date',
      Cell: ({value}) => value && dateFormat(moment(value)),
    },
    {
      Header: 'Drop off',
      accessor: 'booking.dropoff.date',
      Cell: ({value}) => value && dateFormat(moment(value)),
    },
    {
      Header: 'Vehicle Name',
      accessor: 'booking.vehicle.name',
    },
    {
      Header: 'Vehicle Plate',
      accessor: 'booking.vehicle.plate',
    },
    {
      Header: 'Driver',
      accessor: 'booking.vehicle.driver',
    },
    {
      Header: 'Driver Phone',
      accessor: 'booking.vehicle.driverPhone',
    },
    {
      Header: 'Fuel Tag',
      accessor: 'booking.vehicle.fuelTag',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Order Status',
      accessor: 'order.status',
      hideable: true,
      hideDefault: true,
      width: 150,
      Cell: ({value}) => value && <Status value={value} tooltip={false} />,
      filterMethod: (filter, row) => {
        const activeArray = ['Confirmed', 'Revised']
        const draftArray = ['Draft']
        const nonActiveArray = ['Closed', 'Delivered', 'Cancelled']
        if (filter.value === 'all') {
          return true
        }
        if (filter.value === 'draft') {
          return draftArray.includes(row[filter.id])
        }
        if (filter.value === 'Held') {
          return row[filter.id] === 'Held'
        }
        return filter.value === true
          ? activeArray.includes(row[filter.id])
          : nonActiveArray.includes(row[filter.id])
      },
      Filter: ({onChange, filter}) => (
        <Select
          onChange={value => onChange(value)}
          style={{width: '100%'}}
          value={filter ? filter.value : true}>
          <Select.Option value="all">All</Select.Option>
          <Select.Option value={'draft'}>Draft</Select.Option>
          <Select.Option value={'Held'}>Held</Select.Option>
          <Select.Option value={true}>Active</Select.Option>
          <Select.Option value={false}>None Active</Select.Option>
        </Select>
      ),
    },
  ]

  render() {
    const {fetchVehicles, fetchingVehicles, vehicles} = this.props
    return (
      <Fragment>
        <CustomTable
          isFilterable={true}
          columns={this.columns}
          fetch={() => fetchVehicles()}
          fetching={fetchingVehicles}
          data={vehicles}
          show={{
            extraColumns: true,
          }}
          defaultFiltered={[
            {
              id: 'order.status',
              value: true,
            },
          ]}
        />
      </Fragment>
    )
  }
}

VehiclesList.propTypes = {}
VehiclesList.defaultProps = {}

export default VehiclesList
